"use strict";

function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t,
    a = require("react"),
    o = e(a),
    n = require("@chakra-ui/react"),
    r = e(require("@laliga-cdac2/button")),
    l = require("@laliga-cdac2/icons"),
    i = require("@chakra-ui/hooks"),
    s = {
  title: "¡Atención! Estás utilizando un navegador no compatible",
  button: "Continuar",
  text: o.createElement(o.Fragment, null, o.createElement("p", null, "Hemos detectado que estás utilizando un explorador web no compatible con la herramienta. Recuerda que todas las aplicaciones coporativas de LaLiga deben utilizarse con el navegador Google Chrome o Microsoft Edge."), o.createElement("p", null, "Por favor, para un correcto uso de la herramienta accede mediante uno de los navegadores autorizados: Google Chrome o Microsoft Edge."), o.createElement("p", null, "Si tiene alguna duda o incidencia técnica, por favor, contacte por Email en la cuenta de correo soporte@laliga.es o al teléfono +34 682 39 24 10 , le contestaremos a la mayor brevedad posible."))
},
    c = {
  title: "Attention! You are using an unsupported browser",
  button: "Continue",
  text: o.createElement(o.Fragment, null, o.createElement("p", null, "We have detected that you are using a web browser that is not compatible with the tool. Remember that all LaLiga corporate applications must be used with the Google Chrome or Microsoft Edge."), o.createElement("p", null, "Please, for a correct use of the tool, access through the authorized Google Chrome or Microsoft Edge browsers."), o.createElement("p", null, "If you have any questions or technical issues, please contact us by email at soporte@laliga.es or by phone +34 682 39 24 10, we will answer you as soon as possible."))
};

!function (e) {
  e[e.defaultVariant = 0] = "defaultVariant", e[e.ligaFVariant = 1] = "ligaFVariant";
}(t || (t = {})), exports.default = function (e) {
  var t = e.display,
      o = void 0 === t ? null : t,
      d = e.language,
      u = e.buttonText,
      m = e.title,
      g = e.children,
      p = e.dismissible,
      h = void 0 === p || p,
      f = e.sessionKey,
      b = void 0 === f ? "browserModalDisplayed" : f,
      E = e.headerColor,
      y = void 0 === E ? "corporateBlack" : E,
      v = e.buttonColor,
      C = void 0 === v ? "secondaryColor" : v,
      M = e.headerProps,
      w = "es" === (void 0 === d ? "es" : d) ? s : c,
      x = !(/Chrome/.test(navigator.userAgent) || navigator.userAgent.includes("CriOS") || navigator.userAgent.includes("EdgiOS")),
      S = function (e) {
    var t = e.display,
        a = e.sessionKey,
        o = i.useDisclosure({
      defaultIsOpen: !0
    }),
        n = o.isOpen,
        r = o.onClose,
        l = "1" === sessionStorage.getItem(a);
    return {
      showModal: n && t && !l,
      closeModal: function closeModal() {
        r(), sessionStorage.setItem(a, "1");
      }
    };
  }({
    display: null !== o ? o : x,
    sessionKey: b
  }),
      k = S.showModal,
      q = S.closeModal,
      A = n.useStyleConfig("BrowserModal", {}, {
    isMultiPart: !0
  }),
      I = A.iconContainer,
      O = A.icon;

  return a.createElement(n.Modal, {
    size: "4xl",
    isOpen: k,
    onClose: q
  }, a.createElement(n.ModalOverlay, null), a.createElement(n.ModalContent, {
    borderRadius: "none",
    display: "grid",
    gridTemplateColumns: "10% 90%",
    padding: "3rem 5rem 0 3rem",
    gridGap: "1rem"
  }, a.createElement(n.Box, {
    d: "flex",
    justifyContent: "end"
  }, a.createElement(n.Stack, {
    __css: I
  }, a.createElement(l.WarningIcon, {
    __css: O
  }))), a.createElement(n.Box, null, a.createElement(n.HStack, {
    color: y + ".500",
    textAlign: "justify",
    margin: "0.5rem 0 1rem"
  }, a.createElement(n.Heading, Object.assign({
    as: "h3",
    size: "md",
    fontStyle: "md",
    "data-testid": "fallback-title-id",
    fontFamily: "'LALIGAText'"
  }, M), m || w.title)), a.createElement(n.Box, {
    alignItems: "center"
  }, a.createElement(n.Stack, null, g || w.text), h && a.createElement(n.ModalFooter, {
    alignItems: "flex-end",
    w: "full",
    "data-testid": "dismissible-container-id"
  }, a.createElement(r, {
    colorScheme: C,
    onClick: q,
    "data-testid": "button-close-id"
  }, u || w.button))))));
};